<template>
    <v-list-item
        @click="goToLink"
    >
        <v-list-item-content>
            <v-list-item-title :class="{ 'active-nav-link': is_active }">{{ link_display_name }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: "SmartNavItem",
    props: {
        'input': {
            type: Object,
            required: true,
        },
        // The parent object listens for partial page loads from Inertia, and so can update this prop accordingly
        'selected': {
            type: Boolean,
            required: false,
            default: function () {
                return false
            }
        },
        // The parent object listens for partial page loads from Inertia, and so can update this prop accordingly
        'current_route': {
            type: String,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            searchTree: (fn) => (obj) =>
                Array.isArray(obj)
                    ? obj.length == 0
                        ? null
                        : this.searchTree (fn) (obj [0]) || this.searchTree (fn) (obj .slice (1))
                    : fn (
                        obj,
                        () => this.searchTree (fn) (obj .children || []),
                        () => obj
                    ),
        }
    },
    mounted() {
      //
    },
    computed: {
        // Indicates active status after a deep scan of this menu item and any children it might have (recursive)
        is_active() {
            let found_in_child_routes = !!(this.findRouteName(this.current_route))
            let result = this.selected || found_in_child_routes
            if (result) {
                this.$emit('selection')
            }
            return result
        },
        // In case we need a different indicator when this isn't the active item, but one of its descendants is (recursive)
        is_submenu_active() {
            let found_in_child_routes = !!(this.findRouteName(this.current_route))
            return found_in_child_routes && !this.selected
        },
        // A display-formatter for the name
        link_display_name() {
            // let prefix = this.is_submenu_active ? 'Back to ' : ''
            return `${this.input.name}`
        },
        // A display-formatter for the icon
        link_display_icon() {
            return this.input?.name_icon ? `mdi-${this.input.name_icon}` : ''
        },
    },
    methods: {
        // Better than a standard a href since this will use Inertia to only load the part of the page that's required
        goToLink() {
            try {
                if (!route().check(this.input?.name_route)) {
                    throw "That page is still under construction"
                }

                this.$inertia.visit(route(this.input?.name_route), {
                    method: 'get',
                    data: {},
                    replace: false,
                    preserveState: true,
                    preserveScroll: true,
                    only: [],
                    headers: {},
                    onCancelToken: cancelToken => {
                    },
                    onCancel: () => {
                    },
                    onStart: visit => {
                    },
                    onProgress: progress => {
                    },
                    onSuccess: page => {
                    },
                    onFinish: () => {
                    },
                })
            } catch ($ex) {
                console.error($ex)
                this.$root.snackbar.error($ex)
            }

        },
        // Search recursively for an id through haystack+children...
        findId(target) {
            return this.searchTree (
                (node, next, found) => node.id === target ? found () : next(),
            ) (this.input)
        },
        // Search recursively for a route by name through haystack+children...
        findRouteName(target) {
            return this.searchTree (
                (node, next, found) => node.name_route === target ? found () : next(),
            ) (this.input)
        },

    },
}
</script>

<style scoped>
    .active-nav-link {
        text-decoration: underline;
    }
</style>
